module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/case-study-small-biz-22359b77011715a1484d7a517259ed0d.jpg";